import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapPlanChecks } from "../Types/PlanCheck/PlanCheckType";
import { getPlanCheckByFolderId } from "../../Api/PlanCheck/PlanCheckApiServices";

// get all spending project list
export const getAllPlanChckList = createAsyncThunk('getAllPlanChckList', async (folder_id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getPlanCheckByFolderId(folder_id);
    if (response.status) {
      return mapPlanChecks(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});
